module.exports = __webpack_public_path__ + "img/p1_bg.85e6d7ca.jpg";